import { getDate, isToday } from 'date-fns';
import moment from 'moment';
import React, { useEffect } from 'react';
import { DayHeaderSC } from './day-header.styled';

interface DayHeaderProps {
  date: string;
  isLastDay: boolean;
  isFirstDay: boolean;
  setRect: (rect: DOMRect) => void;
}

const DayHeader: React.FunctionComponent<DayHeaderProps> = ({
  date,
  isFirstDay,
  isLastDay,
  setRect,
}) => {
  const dateObj = new Date(date);
  const sameDay = isToday(dateObj);
  const dayHeaderRef = React.useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (dayHeaderRef.current) {
      setRect(dayHeaderRef.current.getBoundingClientRect());
    }
  }, [dayHeaderRef.current]);

  return (
    <DayHeaderSC ref={dayHeaderRef}>
      {isFirstDay ? (
        <div className={'week-overlay-left'}>
          <div className={'bar'}></div>
        </div>
      ) : null}
      <div className="day-name">{moment(dateObj).format('ddd')}</div>
      <div className={`day-date ${sameDay ? 'same' : ''}`}>{getDate(dateObj)}</div>
      {isLastDay ? (
        <div className={'week-overlay-right'}>
          <div className={'bar'}></div>
        </div>
      ) : null}
    </DayHeaderSC>
  );
};

export default React.memo<DayHeaderProps>(DayHeader);
